<template>
    <div class="drawer"
         :class="{'header': isHeader,
                  'highlighted': isSelected,
                  'hide-on-mobile': hideOnMobile,
                  'drawer-open': drawerOpen,
                  'on-hover': menuOnHover,
                  'closed-menu': !isMenuOpen}">
        <span class="inline-link"
               v-if="hasAction"
              @click="$emit('itemClicked')">
             <GeneralLink :path="actionPath" :isExternal="actionIsExternal">
                 {{ actionText }}
             </GeneralLink>
        </span>
        <span class="section-name"
              :class="{ link: path, 'font-8': isHeader, 'disable-repeat-click': disableRepeatClick}"
              @click="$emit('itemClicked')"
        >
            <IconBase v-if="icon"
                      class="section-icon"
                      verticalAlign="middle"
                      :iconName="icon.name"
                      :iconColor="sectionIconColor"
                      :height="icon.height"
                      :width="icon.width"
            ></IconBase>
            <span class="section-title"
                  v-once v-if="!path"
                  :class="{ 'group-title': hasChildren && !isHeader }">
                {{ displayText }}
            </span>
            <span @click="digest()" v-else >
                <GeneralLink
                    :path="path"
                    :openInNewTab="openInNewTab"
                    :isExternal="externalRoute"
                    class="section-title link"
                >
                    {{ displayText }}
                    <IconBase iconName="externalLinkIcon"
                              width="10"
                              height="10"
                              @mouseenter="externalHover = true"
                              @mouseleave="externalHover = false"
                              :iconColor="externalHover ? consts.COLORS.PRIMARY_500 : consts.COLORS.WHITE"
                              v-if="openInNewTab">
                    </IconBase>
                </GeneralLink>
            </span>
            <span class="triangle-icon" :class="{'arrow-right': !drawerOpen}">
                <IconBase iconName="menuIcon"
                          width="9"
                          height="8"
                          :iconColor="consts.COLORS.WHITE"
                          v-if="hasChildren && isHeader">
                </IconBase>
            </span>
        </span>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import GeneralLink from 'components/layout/GeneralLink.vue';
import { safeDigest } from 'services/utils/angularUtils';

export default {
    name: 'Item',
    components: { GeneralLink, IconBase },
    props: {
        hasChildren: Boolean,
        drawerOpen: Boolean,
        displayText: String,
        actionPath: String,
        actionIsExternal: {
            type: Boolean,
            default: false
        },
        actionText: String,
        hideOnMobile: Boolean,
        hasAction: Boolean,
        icon: Object,
        path: String,
        isSelected: Boolean,
        openInNewTab: Boolean,
        isMenuOpen: Boolean,
        menuOnHover: Boolean,
        isHeader: Boolean,
        externalRoute: Boolean,
        disableRepeatClick: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            consts,
            externalHover: false
        };
    },
    computed: {
        sectionIconColor() {
            return this.isSelected ? consts.COLORS.PRIMARY_500 : consts.COLORS.WHITE;
        }
    },
    methods: {
        digest() {
            safeDigest();
        }
    }
};
</script>

<style scoped lang="scss">
@import "../common";
@import "~styles/functions";

$itemHeight: 32px;

@mixin menuLink {
    color: $menuItemFontColor;
    display: block;
    text-decoration:none;
}

.drawer{
    height: $itemHeight;
    line-height: $itemHeight;

    &.header {
        height: $sectionHeight - 1px;
        line-height: $sectionHeight - 1px;
        cursor: pointer;
    }
}

.closed-menu .triangle-icon {
    opacity: 0;
}
.closed-menu.on-hover .triangle-icon {
    opacity: 1;
}
.triangle-icon {
    position: absolute;
    right: 20px;

    @media #{$mobile}{
        display: none;
    }

    transition: opacity $menuAnimations;

    &.arrow-right {
        transform: rotate(-90deg);
        right: 18px;
    }
}

.highlighted .section-name {
    color: $selectedColor;

    a {
        color: $selectedColor;

        @include font(4);

        &:hover, &:active{
            color: $selectedColor;
        }
    }

    &.disable-repeat-click {
        cursor: default;
        a {
            pointer-events: none;
        }
    }
}
.header .section-name:hover {
    color: $menuItemFontColor;
    a {
        color: $menuItemFontColor;

        &:hover, &:active{
            color: $menuItemFontColor;
        }
    }
}
.header.highlighted .section-name:hover, .section-name:hover {
   color: $selectedColor;
   a {
       color: $selectedColor;

       &:hover, &:active{
           color: $selectedColor;
       }
   }
}
.drawer-open .section-name {
    @media #{$mobile}{
        border-bottom: none;
    }
}

.closed-menu .section-name {
    .section-title{
        opacity: 0;
    }
}
.closed-menu.on-hover .section-name {
    .section-title{
        opacity: 1;
    }
}

.section-name {
    width: 100%;
    display: block;
    cursor: pointer;
    white-space: nowrap;
    color: $menuItemFontColor;

    a {
        @include menuLink;
        display: block;

        &:hover, &:active {
            color: $menuItemFontColor;
        }
    }
}

.section-title {
    margin-left: 11px;
    opacity: 1;
    vertical-align: middle;
    transition: opacity $menuAnimations;

    &.group-title {
        @include font(8);
        color: $light-800;
        cursor: default;
    }
}

a {
    @include font(5);
    @include menuLink;
    white-space: nowrap;

    //pointer-events: none;
    //cursor: default;
    //&.enableClickRepeat {
    //    pointer-events: auto;
    //    cursor: pointer;
    //}

    @media #{$tabletAndAbove}{
        &.no-pages-group {
            padding-left: 0;
        }
    }

    @media #{$mobile}{
        &.no-pages-group {
            line-height: 32px;
        }
    }
}

.closed-menu .inline-link {
    opacity: 0;
}
.closed-menu.on-hover .inline-link {
    opacity: 1;
}
.inline-link{
    position: absolute;
    right: 2px;
    top: 0;
    transition: opacity $menuAnimations;
    a, a:link, a:visited, a:active, a:focus {
        color: $selectedColor;
        @include font(6);
    }
}
</style>
